// Runtime loader for the MicroSIP UMD bundle.
// This avoids relying on static UMD/CommonJS interop during the build.

const SCRIPT_SRC = new URL('./MicroSIP.js', import.meta.url).href;

function loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
        if (typeof window === 'undefined') {
            return reject(new Error('window is not available'));
        }
        if ((window as any).MicroSIP) {
            return resolve();
        }
        const existing = Array.from(document.getElementsByTagName('script')).find(s => s.src === src);
        if (existing) {
            if ((existing as any).loaded) return resolve();
            existing.addEventListener('load', () => resolve());
            existing.addEventListener('error', (e) => reject(e));
            return;
        }
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        // execute in order (not async) — append will load/execute, onload fires after execution
        script.async = false as any;
        script.addEventListener('load', () => {
            (script as any).loaded = true;
            resolve();
        });
        script.addEventListener('error', (e) => reject(new Error('Failed to load MicroSIP script: ' + e)));
        document.head.appendChild(script);
    });
}

export async function ensureMicroSIP(): Promise<any> {
    if (typeof window === 'undefined') throw new Error('No window');
    if ((window as any).MicroSIP) return (window as any).MicroSIP;
    await loadScript(SCRIPT_SRC);
    const ms = (window as any).MicroSIP;
    if (!ms) throw new Error('MicroSIP did not attach to window after loading script');
    return ms;
}

export function getMicroSIP(): any {
    return (window as any).MicroSIP;
}

// Default export is a lazy proxy that returns the global MicroSIP if available.
const MicroSIPProxy = new Proxy({}, {
    get(_, prop) {
        return (window as any).MicroSIP ? (window as any).MicroSIP[prop as any] : undefined;
    },
    apply() {
        return (window as any).MicroSIP.apply(this, arguments as any);
    }
});

export default MicroSIPProxy;
